import * as routes from 'api/routes';
import { IModel } from 'models/news/interface';

export type Params = null;
export type Result = Array<IModel>;

export const ROUTE = routes.NEWS_WEBSITE_GET;
